import { render } from "./ItemListOnly.vue?vue&type=template&id=33ef5270"
import script from "./ItemListOnly.vue?vue&type=script&lang=js"
export * from "./ItemListOnly.vue?vue&type=script&lang=js"

import "./ItemListOnly.vue?vue&type=style&index=0&id=33ef5270&lang=css"
import "./ItemListOnly.vue?vue&type=style&index=1&id=33ef5270&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__